import { PhoneNumberUtil } from "google-libphonenumber";
import PhoneInput2 from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import * as Yup from "yup";
export type PhoneInputProps = {
  error?: string;
  [key: string]: any;
  onChnage: (value: string) => any;
  placeholder: string;
  value: string;
  // Code ISO2 en minuscule (ex. "bj"). Renseigne, l'indicatif est verrouille
  // sur ce pays et le selecteur de drapeau est desactive.
  country?: string;
};

const phoneUtil = PhoneNumberUtil.getInstance();

// On ne verifie QUE l'indicatif : ni prefixe, ni longueur. Les bibliotheques
// sont en retard sur les regulateurs, chacune a son rythme (la Cote d'Ivoire
// bloquee a 8 chiffres d'un cote, en exigeant 10 de l'autre ; le 72
// senegalais inconnu), et chaque regle de longueur a fini par refuser de
// vrais numeros. On n'analyse donc meme plus le numero avec la bibliotheque,
// qui impose ses propres longueurs. La validation du numero lui-meme est faite
// par Paydunya au moment du paiement, par OTP ou push operateur.
const chiffres = (phone?: string) => (phone || "").replace(/\D/g, "");

// Un champ reste sur l'indicatif seul (« +221 ») n'est pas un numero.
function indicatifSeul(n: string) {
  return n.length <= 3 && phoneUtil.getRegionCodeForCountryCode(Number(n)) !== "ZZ";
}

// Le numero commence par l'indicatif du pays, suivi d'au moins un chiffre.
function aIndicatifDe(n: string, region: string) {
  const indicatif = String(phoneUtil.getCountryCodeForRegion(region));
  return n.startsWith(indicatif) && n.length > indicatif.length;
}

export type PhoneValidationOptions = {
  // Region utilisee pour interpreter un numero saisi sans indicatif.
  region?: string;
  // Exige en plus que l'indicatif du numero soit celui de `region`.
  strict?: boolean;
};

export function validatePhone(
  yup: typeof Yup,
  { region = "SN", strict = false }: PhoneValidationOptions = {}
) {
  return yup
    .string()
    .test("passwords-match", "Numéro téléphone invalide", (phone) =>
      validateNumber(phone, region, strict)
    )
    .label("Téléphone");
}

function validateNumber(phone?: string, region = "SN", strict = false) {
  const n = chiffres(phone);
  if (!n || indicatifSeul(n)) return false;
  return strict ? aIndicatifDe(n, region) : true;
}

// Vrai si le numero porte l'indicatif du pays donne. Sert a ne pas pre-remplir
// le formulaire avec un numero d'un autre pays que celui choisi.
export function isPhoneOfRegion(phone: string, region?: string) {
  if (!phone || !region) return false;
  return aIndicatifDe(chiffres(phone), region);
}

export default function PhoneInput(props: PhoneInputProps) {
  const { error, onChnage, placeholder, value, country, ...rest } = props;
  const locked = !!country;
  return (
    <div className="form-group mb-3 warning-asterix-content">
      <span className="warning-asterix">*</span>
      <PhoneInput2
        key={country || "sn"}
        inputClass="majjal-form-control form-control form-control-lg"
        country={country || "sn"}
        onlyCountries={locked ? [country as string] : undefined}
        disableDropdown={locked}
        inputProps={{
          ...rest,
        }}
        prefix="+"
        value={value}
        copyNumbersOnly={false}
        // Sans mise en forme, plus de masque par pays : c'est le masque qui
        // plafonnait la saisie (8 chiffres pour la Cote d'Ivoire). Le numero
        // s'affiche sans espaces, mais tout numero reel peut etre tape.
        autoFormat={false}
        enableAreaCodes={true}
        placeholder={placeholder}
        onChange={(v) => onChnage(v.includes("+") ? v : "+" + v)}
        countryCodeEditable={!locked}
        inputStyle={{ width: "100%", height: 48 }}
      />
      {error && (
        <div className="alert alert-danger sia-alert-danger closer mt-2">
          {error}
        </div>
      )}
    </div>
  );
}
